import { InjectionToken } from '@angular/core';
import { Injectable } from '@angular/core';
import { ApiEndpointConfig, ApiUrlConfig, } from '@hrra/core';
import * as P from 'pino';
import { LogginService } from '@hrra/core';
import { ApiTypes } from './api-types';


//let apiBase = '/../api/v2/';

export interface ApiEndpoint {
  url: string;
  analyticUrl: string;
}


export interface UrlConfig {

  customer: {
    get: string;
    getList: string;
    getListCount: string;
    cvBoxApply: string;
  };

  admin: {
    jobseeker: {
      get:string;
      save:string;
      download: string;
      document: {
        uploadTemp: string,
        upload: string
      },
      downloadExperienceAttachment: string;
      downloadEducationAttachment: string;
      downloadLanguageAttachment: string;
      downloadDocument: string;
    }
  };

  announcements: {
    list: string;
    listNew: string;
    getMeta: string;
    favorites: string;
    getRefreshedFavoriteIds: string;
    search: string;
    get: string;
    getSearchField: string;
    apply: string;
    announcementView: string;
    getAnnouncementStats: string;
  };

  jobseekers: {
    list: string;
    get: string;

    downloadDocument: string;
    downloadLanguageAttachment: string;
    downloadEducationAttachment: string;
    downloadExperienceAttachment: string;

    edit: string;

    jobseekerSubscriptionLookup: string;

    validateEmail: string;
    register: string;
    resendActivationEmail: string;
    verifyEmail: string;
    uploadTempFile: string;

    privacy: string;
    requestVerificationCode: string;
    confirmJobseekerEmailUpdate: string;
    initialEmailChange: string;
    changePassword: string;
    blacklist: string;

    resetPassword: string;

    subscription: {
      get: string;
      edit: string;
      unsubscribe: string;
    };

    skillSuggestions: string;

    cvExport: string;
    applications: string;
    cvBoxApplications: string;
    inviteList: string;
    inviteView: string;
    inviteRespond: string;
  };

  skills: {
    skillSuggestions: string;
    skillList: string;
  },

  subscribers: {
    get: string;
    edit: string;
    lookup: string;
    validateEmail: string;
    subscribe: string;
    unsubscribe: string;
    resendActivationEmail: string;
    verifyEmail: string;
  };

  cvBox: {
    list: string;
  };

  auth: {
    login: string;
    loginAsAdmin: string;
    logout: string;
    refreshAccessToken: string;
    getUserInfo: string;
    customerSignIn: string;
  };

  lookup: {
    common: string;
    partnerSites: string;
    providerWebsite: string;
    jobseekerLookup: string;
  };

  configs: {
    get: string;
  };

  infoPage: {
    get: string;
  };

  seoData: {
    cvRegistrationPage: string;
    subscriptionPage: string;
  };

  location: {
    get: string;
    getLocationTree: string;
  };
  banner: {
    insertClick: string,
    getList: string,
  }
  specialization: {
    getSpecializationTree: string;
    getSpecializationList: string;
  }
  industry: {
    getIndustryTree: string;
    getIndustryList: string;
  }

}

export interface AnalyticUrlConfig {
  banner: {
    insertClick: string,
    bannerView: string,
  };
  announcement: {
    announcementView: string
  }

}

export let analyticUrlConfig: AnalyticUrlConfig = {
  banner: {
    insertClick: 'banner/click',
    bannerView: 'banner/view'
  },
  announcement: {
    announcementView: 'announcement/view'
  }
};

export let urlConfig: UrlConfig = {

  customer: {
    get: 'customer/{id}',
    getList: 'companies',
    getListCount: 'customer-count',
    cvBoxApply: 'cvbox-apply',
  },

  admin: {
    jobseeker: {
      get: 'JobseekerModeration/Profile',
      save: 'JobseekerModeration/Profile',
      download: 'JobseekerModeration/Profile',
      document: {
        uploadTemp: 'JobseekerModeration/temp-upload',
        upload: 'JobseekerModeration/Profile'
      },
      downloadExperienceAttachment: 'JobseekerModeration/profile/workexperience/{experienceId}/{jobseekerId}/attachment',
      downloadEducationAttachment: 'JobseekerModeration/profile/education/{objectId}/{jobseekerId}/attachment',
      downloadLanguageAttachment: 'JobseekerModeration/profile/language/{objectId}/{jobseekerId}/attachment',
      downloadDocument: 'JobseekerModeration/profile/document/{objectId}/{jobseekerId}/attachment'
    }
  },

  announcements: {
    list: 'announcements-main',
    listNew: 'announcements-main-new',
    getMeta: 'get-metadata',
    favorites: 'announcement-favorites',
    getRefreshedFavoriteIds: 'refresh-favorites',
    search: 'announcement-search',
    getAnnouncementStats: 'announcement-stats/{id}',
    get: 'announcement/{id}',
    getSearchField: 'search-field',
    apply: 'apply',
    announcementView: 'announcement-view',
  },

  jobseekers: {
    list: '/jobseekers',
    get: 'jobseeker/profile',

    downloadDocument:
      'jobseeker/profile/document/{jobseekerDocumentObjectId}/attachment',
    downloadLanguageAttachment:
      'jobseeker/profile/language/{jobseekerLanguageId}/attachment',
    downloadEducationAttachment:
      'jobseeker/profile/education/{jobseekerEducationId}/attachment',
    downloadExperienceAttachment:
      'jobseeker/profile/workexperience/{experienceId}/attachment',

    edit: 'jobseeker/profile',

    jobseekerSubscriptionLookup: 'jobseeker/jobseeker-subscriber-lookup',

    validateEmail: 'jobseeker/validate-email',
    register: 'jobseeker/register',
    resendActivationEmail: 'jobseeker/resend-activation-email',
    verifyEmail: 'jobseeker/verify-email',
    uploadTempFile: 'jobseeker/temp-upload',

    privacy: 'jobseekersettings/privacy',
    requestVerificationCode: 'jobseekersettings/request-validation-code',
    initialEmailChange: 'jobseekersettings/validate-email-change',
    confirmJobseekerEmailUpdate: 'jobseekersettings/confirm-email-change',
    changePassword: 'jobseekersettings/change-password',
    blacklist: 'jobseekersettings/blacklist',

    resetPassword: 'jobseeker/reset-password',

    subscription: {
      get: 'jobseeker/subscription',
      edit: 'jobseeker/subscription',
      unsubscribe: 'jobseeker/unsubscribe'
    },

    skillSuggestions: 'jobseeker/jobseeker-skill-suggestions',

    cvExport: 'jobseeker/cv-export',
    applications: 'jobseeker/application-list',
    cvBoxApplications: 'jobseeker/cv-box-application-list',
    inviteList: 'jobseeker/invite-list',
    inviteView: 'jobseeker/invite-view',
    inviteRespond: 'jobseeker/invite-respond',
  },

  subscribers: {
    get: 'subscriber/subscription',
    edit: 'subscriber/subscription',
    lookup: 'subscriber/subscriber-lookup',
    subscribe: 'subscriber/subscribe',
    unsubscribe: 'subscriber/unsubscribe',

    verifyEmail: 'subscriber/verify-email',
    validateEmail: 'subscriber/validate-email',
    resendActivationEmail: 'subscriber/resend-activation-email',
  },

  cvBox: {
    list: 'public/cvbox',
  },

  auth: {
    login: 'auth/signin',
    loginAsAdmin: 'auth/signin-as-admin',
    logout: 'auth/signout',
    refreshAccessToken: 'auth/refresh-access-token',
    getUserInfo: 'auth/get-user-info',
    customerSignIn: 'auth/customer-signin',
  },

  lookup: {
    common: 'public/common/lookup',
    partnerSites: 'public/partnerSites',
    providerWebsite: 'public/common/provider-website',
    jobseekerLookup: 'public/common/jobseeker-lookup',
  },

  configs: {
    get: 'public/configs',
  },

  infoPage: {
    get: 'info/{alias}',
  },

  skills: {
    skillSuggestions: 'skill-suggestions',
    skillList: 'skill-list'
  },

  seoData: {
    cvRegistrationPage: 'cv-registration-page-seo-data',
    subscriptionPage: 'subscription-page-seo-data',
  },

  location: {
    get: 'public/location/locations',
    getLocationTree: 'public/location/GetLocationTree',
  },
  banner: {
    insertClick: "insert-click",
    getList: "get-banners"
  },
  specialization: {
    getSpecializationTree: 'public/specialization/GetSpecializationTree',
    getSpecializationList: 'public/specialization/GetSpecializationList'
  },
  industry: {
    getIndustryTree: 'public/industry/GetIndustryTree',
    getIndustryList: 'public/industry/getIndustryList',
  }
};



export interface UrlConfigContainer extends ApiEndpointConfig
{
  api: ApiUrlConfig<UrlConfig>;
  analytics: ApiUrlConfig<AnalyticUrlConfig>;
}


export const newUrlConfig: UrlConfigContainer = 
{
  api: {
    apiType: ApiTypes.PublicApi,
    data: urlConfig
  },
  analytics: {
    apiType: ApiTypes.AnalyticsApi,
    data: analyticUrlConfig
  }
};
